import { LinkBoxList, Main } from 'ui/components';
import { ModuleMapFeature } from 'features/Mappers/Module';
import { useDynamicNavigationLinks } from '../shared/useDynamicNavigationLinks';

export const ContentPageFeature: React.FC<Umbraco.ContentPage> = ({ properties }) => {
	const { pageHeader, pageSections, pageSettings } = properties ?? {};
	const { useDynamicNavigation, dynamicLinks, heading } = useDynamicNavigationLinks(pageSettings);

	const lastSection = pageSections?.[pageSections.length - 1];
	const linkBoxSectionWidth = lastSection?.settings?.properties?.width || 'Standard';

	const isHeaderBanner = pageHeader[0]?.content?.documentType?.toString() === 'topBanner';
	return (
		<Main
			header={pageHeader?.map((headerModule, index) => (
				<ModuleMapFeature key={index} contentModule={headerModule} />
			))}
			isHeaderBanner={isHeaderBanner}
		>
			{pageSections?.map((sectionModule, index) => (
				<ModuleMapFeature key={index} contentModule={sectionModule} />
			))}

			{useDynamicNavigation && dynamicLinks.length > 0 && (
				<LinkBoxList
					items={[{ heading, links: dynamicLinks, variant: 'inline' }]}
					desktopWidth="100"
					mobileWidth="100"
					containerWidth={linkBoxSectionWidth}
				/>
			)}
		</Main>
	);
};
